module.exports = __webpack_public_path__ + "static/media/hotel-reservation-icon.94ab338d.svg";